import { Flex, Form } from 'antd'
import { FormattedMessage, useIntl } from 'react-intl'
import Text from 'shared/components/typography/Text'
import cn from 'classnames'
import { formKeys } from '../../DonationForm/constants'
import PayToUploadButton from '../../PayToUploadButton'
import { lang as commonLang } from '../lang'
import { MediaPriceLimit } from '../hooks/useMediaPricesLimits'
import s from './s.module.css'
import { lang } from './lang'
import Recording from './Recording'
import VoiceRecordIcon from './voiceRecord.svg?react'
import { FormValues } from '@/pages/Donation/types'

type Props = {
  mediaPriceLimit?: MediaPriceLimit
  onSetFiatAmount: (value: string) => void
}

export default function AudioDonation(props: Props) {
  const intl = useIntl()

  return (
    <Form.Item
      name={formKeys.audio}
      rules={[
        {
          required: true,
          message: intl.formatMessage(lang.audioError),
        },
      ]}
    >
      <Content {...props} />
    </Form.Item>
  )
}

function Content({ mediaPriceLimit, onSetFiatAmount }: Props) {
  const form = Form.useFormInstance<FormValues>()
  const baseCurrency = Form.useWatch<FormValues[typeof formKeys.baseCurrency]>(formKeys.baseCurrency)
  const isEnoughAmount = mediaPriceLimit == null

  const { errors } = Form.Item.useStatus()

  return (
    <Flex gap={8} className={cn(s.wrap, errors?.length > 0 && s.error)} justify="space-between" align="center">
      {isEnoughAmount ? (
        <Recording
          onSetAudio={value => {
            form.setFieldValue(formKeys.audio, value)
            form.validateFields([formKeys.audio])
          }}
        />
      ) : (
        <Flex gap={8}>
          <div className={s.icon}>
            <VoiceRecordIcon />
          </div>
          <Flex vertical gap={4}>
            <Text fontSize={14} fontType="body" color="var(--grey-100)">
              <FormattedMessage {...lang.addAudio} />
            </Text>
            <Text>
              <FormattedMessage
                {...commonLang.payToAdd}
                values={{
                  type: 'Audio',
                  action: (
                    <PayToUploadButton
                      amount={Number(mediaPriceLimit?.payAmount)}
                      currencyCode={baseCurrency?.code}
                      onClick={() => onSetFiatAmount(String(mediaPriceLimit?.totalMinAmount))}
                    />
                  ),
                }}
              />
            </Text>
          </Flex>
        </Flex>
      )}
    </Flex>
  )
}
